function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowM15 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m-8949.461-8528.567 5.578 5.575-5.578 5.577",
  "data-name": "Path 468",
  style: {
    fill: "none",
    stroke: "#9d9d9d",
    strokeLinejoin: "round",
    strokeWidth: "1.2px"
  },
  transform: "translate(8954.172 8530.491)"
}));
export default SvgIconArrowM15;